import { Logger } from 'tslog'

/**
 * @deprecated commonに置くべきでない処理が行われている。backendに移動させるべき。
 */
export const simpleLogger = new Logger({
  type: 'json',
})
